import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../../icons";
import { DriverStateRecord, listDriverStates } from "../../../api";

export function DriverFatiguePanel() {
  const { t } = useTranslation("dashboard");
  const [state, setState] = useState<DriverStateRecord | null>(null);

  useEffect(() => {
    const tick = async () => {
      try {
        const all = await listDriverStates({ risky_only: false });
        // En riskli aracı pick et: önce critical, sonra high, sonra max perclos.
        const order = (s: DriverStateRecord) =>
          s.alert_severity === "critical"
            ? 100
            : s.alert_severity === "high"
              ? 50
              : s.alert_severity === "medium"
                ? 20
                : s.perclos_pct;
        const sorted = [...all].sort((a, b) => order(b) - order(a));
        setState(sorted[0] ?? null);
      } catch {
        // silent; panel renders empty state below
      }
    };
    void tick();
    const t = setInterval(tick, 15_000);
    return () => clearInterval(t);
  }, []);

  if (!state) {
    return (
      <>
        <header className="panel-head">
          <h3>
            <Icon name="eye" size={18} /> {t("panels.driver.title")}
          </h3>
          <span className="panel-tag">{t("panels.driver.noDataTag")}</span>
        </header>
        <div className="empty-card">
          <Icon name="eye" /> {t("panels.driver.noDataCard")}
        </div>
      </>
    );
  }

  const sev = state.alert_severity;
  const sevLabel =
    sev === "critical"
      ? t("panels.driver.critical")
      : sev === "high"
        ? t("panels.driver.high")
        : sev === "medium"
          ? t("panels.driver.medium")
          : t("panels.driver.low");

  return (
    <>
      <header className="panel-head">
        <h3>
          <Icon name="eye" size={18} /> {t("panels.driver.title")}
        </h3>
        <span className="panel-tag">{t("panels.driver.vehicleTag", { id: state.vehicle_id })}</span>
      </header>
      <div className="driver-body">
        <div className="driver-summary">
          <div className="driver-avatar">
            <Icon name="users" size={42} />
          </div>
          <div>
            <div className="driver-label">{t("panels.driver.fatigueLevel")}</div>
            <div className="driver-level">{sevLabel}</div>
            <div className="driver-pct">PERCLOS %{state.perclos_pct.toFixed(0)}</div>
          </div>
        </div>
        <ul className="driver-metrics">
          <li className={`metric-row tone-${state.perclos_pct >= 30 ? "rose" : "amber"}`}>
            <span>{t("panels.driver.perclos")}</span>
            <span>%{state.perclos_pct.toFixed(0)}</span>
          </li>
          <li className={`metric-row tone-${state.microsleep_risk >= 0.7 ? "rose" : "amber"}`}>
            <span>{t("panels.driver.microsleep")}</span>
            <span>{(state.microsleep_risk * 100).toFixed(0)}%</span>
          </li>
          <li className="metric-row tone-amber">
            <span>{t("panels.driver.yawns")}</span>
            <span>{state.yawns_15min}</span>
          </li>
          <li className="metric-row tone-amber">
            <span>{t("panels.driver.headDrops")}</span>
            <span>{state.head_drops_15min}</span>
          </li>
        </ul>
      </div>
    </>
  );
}
